import apiClient from '../../shared/services/apiClient';

const blogService = {
    getPosts: (params = {}) =>
        apiClient.get('/api/admin/blog/posts', { params }).then(res => res.data),
    getPost: (id) =>
        apiClient.get('/api/admin/blog/posts/get', { params: { id } }).then(res => res.data),
    createPost: (payload) =>
        apiClient.post('/api/admin/blog/posts/create', payload).then(res => res.data),
    updatePost: (payload) =>
        apiClient.post('/api/admin/blog/posts/update', payload).then(res => res.data),
    deletePost: (id) =>
        apiClient.delete('/api/admin/blog/posts/delete', { data: { id } }).then(res => res.data),

    getCategories: () =>
        apiClient.get('/api/admin/blog/categories').then(res => res.data),
    createCategory: (payload) =>
        apiClient.post('/api/admin/blog/categories/create', payload).then(res => res.data),
    updateCategory: (payload) =>
        apiClient.post('/api/admin/blog/categories/update', payload).then(res => res.data),
    deleteCategory: (id) =>
        apiClient.delete('/api/admin/blog/categories/delete', { data: { id } }).then(res => res.data),

    getTags: () =>
        apiClient.get('/api/admin/blog/tags').then(res => res.data),
    createTag: (payload) =>
        apiClient.post('/api/admin/blog/tags/create', payload).then(res => res.data),
    updateTag: (payload) =>
        apiClient.post('/api/admin/blog/tags/update', payload).then(res => res.data),
    deleteTag: (id) =>
        apiClient.delete('/api/admin/blog/tags/delete', { data: { id } }).then(res => res.data)
};

export default blogService;
